import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BootOpenIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M19.9999 8.61938L19.1869 8.15934C18.2418 7.57298 17.1594 7.26243 16.0551 7.26243L11.7599 7.26338C11.3368 7.28358 10.9184 7.35665 10.5137 7.48043L6.44309 5.14026L6.23479 5.02051H5.99453H2.65991V6.82051H5.75426L8.40212 8.34274L3.99374 10.2029V15.4949L6.55076 16.6564C7.54321 19.975 11.4679 19.7444 12.465 17.1533H19.9999V15.3533H12.465H11.229L10.7851 16.5069C10.5815 17.036 10.0828 17.336 9.55485 17.3217C9.11606 17.3098 8.55276 17.0685 8.2753 16.1407L8.0407 15.3563L7.29523 15.0176L5.79374 14.3355V11.397L10.7699 9.29733C11.103 9.16313 11.4531 9.08443 11.8077 9.06337L16.0551 9.06243H16.0554H16.0555C16.8208 9.06251 17.5749 9.27752 18.238 9.68891L18.2689 9.70805L18.3005 9.72592L19.9999 10.6876V8.61938Z"
      />
    </SvgIcon>
  );
});
